/*** IMPORTS FROM imports-loader ***/
var define = false;

var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

